// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"SectionWrapper_sectionWrapper__MldkZ","labelWrapper":"SectionWrapper_labelWrapper__H9gDv","childrenWrapper":"SectionWrapper_childrenWrapper__Iemkv"};